<template>
    <ul class="nav-mobile">
        <li
            v-for="(nav, index) in navList"
            :key="nav.id"
            class="item"
            :class="{
                active:
                    (!currentListingStatus && index === 0) ||
                    currentListingStatus === nav.id
            }"
            @click="handleClick(nav)"
        >
            {{ nav.name }}
        </li>
    </ul>
</template>

<script>
import { mapState } from '@/store/helpers';

import navCommon from '../../../_mixins/nav/common';

export default {
    name: 'drop-down-nav',
    mixins: [navCommon],
    props: {
        navList: {
            type: Array,
            required: true
        },
        // pc end use ， pass more
        customLabel: {
            type: String,
            default: ''
        }
    },
    computed: {

        ...mapState({
            "currentListingStatusName": "currentListingStatusName"
        }),
        
        label() {
            return this.customLabel || this.currentListingStatusName;
        }
    },
    methods: {
        //  Handle the click event
        handleClick(listing) {
            this.switchNav(listing);
        }
    }
};
</script>

<style lang="scss">
.nav-mobile {
    background: #fff;
    height: 54px;
    display: flex;
    overflow-y: hidden;
    overflow-x: auto;
    border-bottom: 1px solid #dadada;
    margin-bottom: 5px;
    &::-webkit-scrollbar {
        height: 0;
        width: 0;
    }
    li {
        font: 14px var(--font-medium);
        margin-right: 40px;
        height: 100%;
        line-height: 54px;
        white-space: nowrap;
        &:last-child {
            margin-right: 0;
        }
        &.active {
            font-family: var(--font-normal);
            color: var(--color-theme);
            border-bottom: 2px solid var(--color-theme);
        }
    }
}
</style>
